module.exports = __webpack_public_path__ + "img/blog8.dd201971.png";